export default [
    {
        path: '/article-list',
        name: 'article-list',
        component: () => import('@/views/article-list.vue'),
        meta: {
            title: '文章列表'
        }
    }
]